import React, { useState, useEffect } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useParams } from "react-router-dom";
import Axios from "utils/Axios";
import { useNavigate } from "react-router-dom";
//import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import MKBox from "components/MKBox";
import Avatar from "@mui/material/Avatar";
import coverImageDefault from "../../../../assets/images/groove-sign-up.jpg";
//import { Button, LinearProgress  } from '@material-ui/core';
import { Button, LinearProgress } from "@mui/material";
import MKButton from "components/MKButton";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import "./singleEvent.scss";

function SingleEvent() {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { id } = useParams();
  const [rows, setRows] = useState(null);

  const imageUrl = (url) => {
    return process.env.REACT_APP_BASE_IMAGE_URL + url;
  };
  const navigate = useNavigate();
  const gotoEditEvent = (eventId) => {
    navigate(`/admin/events/update/${eventId}`);
  };

  // approve events
  const activateEvent = (isActive) => {
    // start loading bar
    setLoading(true);
    //--- constructing the payload ---
    const data = JSON.stringify({
      type: "adminEvent",
      eventId: id,
      isActive: isActive,
    });
    // console.log(id, "EVENT ID AMIGO");
    // console.log(isActive, "IS ACTIVE");
    Axios.post("/", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        // console.log(response.data, "Event Approved");
        if (response.data.message === "Event Approved") {
          navigate("/admin/events/");
        }
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
      })
      .finally(() => {
        //stop loading
        setLoading(false);
      });
  };
  const copyEvent = (event_id) => {
    setLoading(true);
    setSuccessMessage("");
    setApiError("");
    Axios.post(`?type=copyEvent`, {
      event_id,
    })
      .then((response) => {
        setSuccessMessage(response.data.message);
        navigate(`/admin/events/single/${response.data.new_event_id}`);
      })
      .catch((error) => {
        setApiError(error.response.data.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  // Handle opening the delete confirmation dialog
  const handleOpenDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };

  // Handle closing the delete dialog
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  // Handle deleting an event
  const handleDeleteEvent = () => {
    setDeleteLoading(true);
    Axios.delete(`/?type=event&id=${id}`)
      .then((response) => {
        // Navigate back to events list after successful deletion
        navigate('/admin/events');
      })
      .catch((error) => {
        console.error('Failed to delete event:', error);
        setApiError(error.response?.data?.error || 'Failed to delete event');
      })
      .finally(() => {
        setDeleteLoading(false);
        handleCloseDeleteDialog();
      });
  };
  const gotoEventGallery = (eventId) => {
    navigate(`/promoter/events/settings/${eventId}`);
  };
  const getSigleEvent = () => {
    setLoading(true);
    Axios.get(`?type=event&id=${id}`)
      .then((response) => {
        setRows(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getSigleEvent();
  }, []);
  return (
    <>
      <div className="singleEvent grid grid-cols-1 lg:grid-cols-3 gap-x-4">
        <div className="view col-span-2">
          <div className="info flex flex-col md:flex-row gap-4">
            <div>
              <Avatar
                alt={rows?.title}
                src={imageUrl(rows?.image) || coverImageDefault}
                sx={{ width: 200, height: 200 }}
                variant="rounded"
              />
            </div>
            <div className="details relative">
              <div className="item">
                {/* <span className="itemTitle">Event Name: </span> */}
                <span className="itemValue text-2xl font-semibold">
                  {rows?.title} / {rows?.date}
                </span>
              </div>
              <div className="item">
              </div>
              <div className="item">
                {/* <span className="itemTitle">Event Venue: </span> */}
                <span className="itemValue text-sm text-gray-600 font-thin">{rows?.location} {rows?.venue_name ? ` -  ${rows?.venue_name}` : ""}</span>
              </div>
              {apiError && (
                <div
                  className="bg-[#FEF2F2] border border-red-400 text-red-500 px-4 py-1.5 rounded-lg text-sm relative mb-4"
                  role="alert"
                >
                  <span className="block sm:inline">{apiError}</span>
                </div>
              )}

              {/* Success Message */}
              {successMessage && (
                <div
                  className="bg-[#F0FDF4] border border-green-400 text-green-600 px-4 py-1.5 rounded-lg text-sm relative mb-4"
                  role="alert"
                >
                  <span className="block sm:inline">{successMessage}</span>
                </div>
              )}
              <div className="flex max-sm:flex-col max-sm:gap-2 gap-4 xl:absolute xl: bottom-0">
                <div className="max-sm:w-full">
                  {loading ? (
                    <span>loading....</span>
                  ) : //<LinearProgress color="secondary"/>  // Show LinearProgress when loading is true
                    rows && rows.is_active !== undefined ? ( // Check if rows and is_active are defined
                      rows.is_active === "0" ? (
                        <Button
                          className="max-sm:w-full"
                          disabled={loading}
                          variant="contained"
                          color="success"
                          sx={{ color: "white" }}
                          onClick={() => {
                            activateEvent(1);
                          }}
                        >
                          Approve Event
                        </Button>
                      ) : (
                        <Button
                          className="max-sm:w-full"
                          variant="contained"
                          color="warning"
                          sx={{ color: "white" }}
                          disabled={loading}
                          onClick={() => {
                            activateEvent(0);
                          }}
                        >
                          Deactivate Event
                        </Button>
                      )
                    ) : (
                      <span>Loading...</span> // If rows are not available, show loading text
                    )}
                </div>
                <Button
                  variant="contained"
                  color="info"
                  sx={{ color: "white" }}
                  startIcon={<EditIcon />}
                  disabled={loading}
                  onClick={() => {
                    gotoEditEvent(rows?.id);
                  }}
                >
                  Edit Event
                </Button>
                <Button
                  variant="contained"
                  color="info"
                  sx={{ color: "white" }}
                  startIcon={<EditIcon />}
                  disabled={loading}
                  onClick={() => {
                    gotoEventGallery(id);
                  }}
                >
                  Gallery
                </Button>
                {rows?.date && new Date(rows?.date) < new Date() ? (
                  // Render "Edit Event Data" if the date is in the future
                  <MKBox mb={1}>
                    <MKButton
                      onClick={() => {
                        copyEvent(id);
                      }}
                      variant="gradient"
                      color="secondary"
                      fullWidth
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "Copy Event"}
                    </MKButton>
                  </MKBox>
                ) : (
                  ""
                )}
                <MKBox mb={1}>
                  <MKButton
                    onClick={handleOpenDeleteDialog}
                    variant="gradient"
                    color="error"
                    fullWidth
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Delete Event"}
                  </MKButton>
                </MKBox>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h2 className="text-gray-800 font-semibold mb-5">Description Details</h2>
            <MKBox
              sx={{
                "& p": {
                  marginBottom: 2,
                },
                "& img": {
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: 2,
                },
                "& h2, & h3, & h4, & h5, & h6": {
                  marginTop: 3,
                  marginBottom: 1,
                },
                "& ul, & ol": {
                  marginLeft: 4,
                  marginBottom: 2,
                },
              }}
              color={"dark"}
              className="font-light pr-5"
              dangerouslySetInnerHTML={{ __html: rows?.description }}
            />
          </div>
          <div>
            {/* <button
                        onClick={() => {
                          gotoEventSettings(id);
                        }}
                        type="button"
                        variant="outline"
                        className="focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900"
                      >
                        Event Gallery
                      </button> */}
          </div>
          {/* <div className="chart">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
              </LineChart>
            </ResponsiveContainer>
          </div> */}
        </div>
        <div className="mt-10 md:mt-0">
          {/* <div className="activities">
            <h2>Latest Activities</h2>
            <ul>
              <li>
                <div>
                  <p>Master of Ceremony in the building</p>
                  <time>3 min ago</time>
                </div>
              </li>
              <li>
                <div>
                  <p>DJ and live band commencement</p>
                  <time>20 min ago</time>
                </div>
              </li>
              <li>
                <div>
                  <p>Umuhanzi yahasesekaye</p>
                  <time>53 min ago</time>
                </div>
              </li>
              <li>
                <div>
                  <p>Dancers on the floor</p>
                  <time>1 hour ago</time>
                </div>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Event Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this event? This action cannot be undone and will also delete all associated gallery images.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={handleDeleteEvent} 
            color="error" 
            variant="contained" 
            autoFocus
            disabled={deleteLoading}
          >
            {deleteLoading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SingleEvent;
